<template>
  <div class="slide" id="slide_petition" v-if="isVisibleSlide('petition')">
    <div class="slide-content">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 petition-form">
            <div class="content-wrapper">
              <div class="petition-text">Great, just add your details here to join Megaphone's campaign to protect workers' rights - so that together, we can take on heartless companies and change workplaces for the better:<br><br><span style="font-weight: normal;">'I agree: Everyone deserves safe working conditions and to be treated with respect'</span></div>
              
              <img src="https://storage.googleapis.com/fa-assets/tuc-petition.png?v=3" style="width:100%;max-width: 400px; margin: 0 auto; display: block; margin-top:10px;"/>
              <div class="petition-text">1,519 signatures so far</div>
              
              <form @submit.prevent="submitForm">
                <div class="form-box">
                  <div class="form-group form-group-fn">
                    <label for="fname" required>
                      First name
                      <span class="required-symbol">*</span>
                    </label>
                    <input
                      type="text"
                      name="fname"
                      id="fname"
                      v-model="form.first_name"
                      v-validate="'required|min:1'"
                    />
                    <span
                      v-show="errors.has('fname')"
                      class="validation-error"
                    >First name is required</span>
                  </div>
                  <div class="form-group form-group-ln">
                    <label for="lname">
                      Last name
                      <span class="required-symbol">*</span>
                    </label>
                    <input
                      type="text"
                      name="lname"
                      id="lname"
                      v-model="form.last_name"
                      v-validate="'required|min:1'"
                    />
                    <span
                      v-show="errors.has('lname')"
                      class="validation-error"
                    >Last name is required</span>
                  </div>
                  <div class="form-group form-group-email">
                    <label for="email">
                      Email
                      <span class="required-symbol">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      v-model="form.email"
                      v-validate="'required|email'"
                    />
                    <span
                      v-show="errors.has('email')"
                      class="validation-error"
                    >Please enter a valid Email</span>
                  </div>
                  <div class="optin-text">
                    <strong>Find out how you're winning rights for workers.</strong> We can only tell you about our shared victories against companies like McDonalds if you click yes' below. So, can Megaphone email you updates about this and other campaigns to protect workers’ rights?
                  </div>

                  <div class="form-group form-group-radio">
                    <label class="radio-container">
                      <input
                        type="radio"
                        name="optin"
                        value="yes"
                        v-model="form.optin"
                        v-validate="'required'"
                      />Yes
                      <span class="checkmark"></span>
                    </label>
                    <label class="radio-container">
                      <input
                        type="radio"
                        name="optin"
                        value="no"
                        v-model="form.optin"
                        v-validate="'required'"
                      />No
                      <span class="checkmark"></span>
                    </label>
                    <span
                      v-show="errors.has('optin')"
                      class="validation-error validation-optin"
                    >Please select an option above</span>
                  </div>
                  <div
                    class="optin-warning"
                    v-if="form.optin == 'no'"
                  >If you choose ‘No’ we won’t be able to tell you the next time we win a campaign to improve workers’ rights. Click ‘Yes’ to hear about trade union campaign wins, and get other news and updates - you can opt out at any time.</div>
                </div>
                <div class="buttons-container">
                  <button type="submit" class="btn btn-light red">ADD MY NAME</button>
                </div>
                <div
                  class="petition-disclaimer"
                >We’ll email you campaigns to support unions and workers rights in the UK. Your personal information will be kept private and held securely. You can unsubscribe at any time.</div>
              </form>
              <button
                class="btn btn-skip"
                @click="gotoSlide('results'); analytics('petition', 'clicked skip');"
              >Skip >></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Petition",
  props: ["gotoSlide", "isVisibleSlide", "analytics"],
  data() {
    return {
      form: {
        first_name: "",
        last_name: "",
        email: "",
        optin: "",
        signup_source: "quiz"
      }
    };
  },
  methods: {
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          axios
            .post("/signup", this.form)
            .then(response => {
              this.analytics("petition", "submitted");
              this.analytics("opted in", this.form.optin);
              if (typeof fbq !== 'undefined') {
	              fbq('trackCustom', 'QuizSignup');
              }
            })
            .catch(error => {
              console.log(error);
              this.analytics("petition", "error");
            });
          this.$store.state.firstName = this.form.first_name;
          this.gotoSlide("results");
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.slide-content {
  font-size: 20px;
  .container {
    box-shadow: 0px 0px 10px rgba(70, 70, 70, 0.1);
    text-align: center;
    @media only screen and (max-width: 768px) {
      box-shadow: none;
    }
    .content-wrapper {
      margin: 70px auto 100px auto;
      max-width: 800px;
      @media only screen and (max-width: 768px) {
        margin: 30px auto 30px auto;
      }
    }
  }
}
.petition-text {
  text-align: center;
  font-weight: 600;
  font-size: 17px;
  @media only screen and (max-width: 768px) {
    padding: 0 15px;
    font-size: 15px;
  }
}
.petition-disclaimer {
  text-align: center;
  max-width: 600px;
  margin: 30px auto 10px auto;
  color: #7d7d7d;
  font-size: 13px;
}
.skip-btn {
  margin: 0 auto;
  display: block;
}
.petition-form {
  text-align: left;
  form {
    margin-bottom: 30px;
    @media only screen and (max-width: 768px) {
      margin-top: 0px;
      padding: 0 0px;
    }
    .form-box {
      background: #f6f6f6;
      padding: 30px 30px 10px 30px;
      margin: 30px auto;
      max-width: 650px;
      @media only screen and (max-width: 768px) {
        padding: 20px 15px 10px 15px;
        margin-top: 20px;
      }
    }
    button {
      font-size: 17px;
      margin: 0 auto;
      display: block;
      width: 200px;
      padding: 17px 35px;
      @media only screen and (max-width: 768px) {
        width: 100%;
        max-width: 400px;
        margin-top: 20px;
      }
    }
  }
  .form-group {
    &.form-group-fn {
      width: 50%;
      display: inline-block;
      padding-right: 10px;
      @media only screen and (max-width: 768px) {
        width: 100%;
        padding-right: 0;
      }
    }
    &.form-group-ln {
      width: 50%;
      display: inline-block;
      padding-left: 10px;
      @media only screen and (max-width: 768px) {
        width: 100%;
        padding-left: 0;
      }
    }
    label {
      display: block;
      font-weight: 600;
      font-size: 15px;
      margin-bottom: 5px;
    }
    .required-symbol {
      color: #cd171e;
    }
    input {
      display: block;
      background: #fff;
      border: 1px solid #d6d6d6;
      border-radius: 4px;
      width: 100%;
      padding: 10px;
      font-size: 17px;
    }
    .validation-error {
      display: block;
      font-size: 13px;
      color: #c00;
    }
  }
  .optin-text {
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 10px;
  }
  .form-group-radio {
    .radio-container {
      display: inline-block;
      font-weight: 600;
      font-size: 13px;
      width: 80px;
    }
    input {
      display: inline-block;
      width: 15px;
      margin-right: 10px;
    }
  }
  .validation-optin {
    display: block;
    font-size: 13px;
    color: #c00;
  }
  .optin-warning {
    border: 1px solid #f5e8c3;
    border-radius: 2px;
    background: #f9f0c8;
    font-size: 13px;
    padding: 15px;
    margin-bottom: 20px;
    color: #6b4a0c;
  }
}

/* Custom radio */
.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  vertical-align: middle;
  margin-right: 0px;
  cursor: pointer;
  font-size: 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
/* Hide the browser's default radio button */
.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: -2px;
  left: 0;
  height: 21px;
  width: 21px;
  background-color: #fff;
  border-radius: 50%;
  border: 1px solid #d6d6d6;
}
/* On mouse-over, add a grey background color */
.radio-container:hover input ~ .checkmark {
  background-color: #fff;
}
/* When the radio button is checked, add a blue background */
.radio-container input:checked ~ .checkmark {
  background-color: #fff;
}
/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
/* Show the indicator (dot/circle) when checked */
.radio-container input:checked ~ .checkmark:after {
  display: block;
}
/* Style the indicator (dot/circle) */
.radio-container .checkmark:after {
  top: 3px;
  left: 3px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #cd171e;
}
</style>
